import {
  getCloudinaryImageSources,
  getCloudinaryImageUrl,
} from '../../../../utils/cloudinary';

export const getGalleryImage = (relativeSrc, imageDomain, alt) => {
  return {
    text: alt,
    sources: [
      ...getCloudinaryImageSources(
        imageDomain,
        { relativeSrc, ratio: { a: 2, b: 3, length: 375 } },
        '(max-width: 375px)',
      ),
      ...getCloudinaryImageSources(
        imageDomain,
        { relativeSrc, ratio: { a: 2, b: 3, length: 415 } },
        '(min-width: 376px) and (max-width: 415px)',
      ),
      ...getCloudinaryImageSources(
        imageDomain,
        { relativeSrc, ratio: { a: 2, b: 3, length: 836 } },
        '(min-width: 416px)',
      ),
    ],
    thumbnail: getCloudinaryImageUrl(imageDomain, {
      relativeSrc,
      width: 87,
      height: 58,
    }),
  };
};
